module.exports = __webpack_public_path__ + "static/media/Bridge-Pointe-1st-Restated-By-Laws.b44fcea8.pdf";